import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Header, Form, TextArea, Button, Modal } from 'semantic-ui-react';

import { RefreshModal } from './Modal';

import cm from 'helpers/commons';

class StaffListAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.StaffListFn.invalid !== nextProps.StaffListFn.invalid || this.state.open !== nextState.open;
  }

  show = () => {
    const { checkStaff, StaffListFn } = this.props;

    delete checkStaff.data;
    StaffListFn.dataDelete();
    this.setState({ open: true });
  };

  handleConfirm = () => {
    this.setState({ open: false });
    $('.txtInput').val('');
    this.props.StaffListFn.initialInvalid();
  };

  handleCancel = () => this.setState({ open: false });

  render() {
    const { open } = this.state,
      { devideStaffList, invalid, totalList } = this.props.StaffListFn,
      modalFn = {
        open: open,
        cancel: this.handleCancel,
        confirm: this.handleConfirm
      };

    let btnArea = '',
      txtArea = '';
    let invalidLength = 0;
    if (invalid) {
      btnArea = (
        <Button color="black" onClick={this.show}>
          새로운 정보입력
        </Button>
      );

      invalidLength = invalid.length;
      let invalidRow = invalid.map((item, idx) => {
        return (
          <Table.Row key={idx}>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>{item.value}</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell>{item.reason}</Table.Cell>
          </Table.Row>
        );
      });

      txtArea = (
        <Table basic="very" celled collapsing>
          <Table.Body>{invalidRow}</Table.Body>
        </Table>
      );
    } else {
      btnArea = (
        <Button color="black" onClick={devideStaffList}>
          Step3. 전송목록에 추가하기
        </Button>
      );

      const placeHolderTxt =
        '* 휴대전화번호 or 이메일 주소를 입력해주세요. &#13;&#10; ' +
        '* 붙여넣기로 많은 정보를 한번에 입력할 수 있습니다.';
      txtArea = (
        <Form>
          <TextArea
            placeholder="* 휴대전화번호 or 이메일 주소를 입력해주세요. &#13;&#10;* 붙여넣기로 많은 정보를 한번에 입력할 수 있습니다."
            className="txtInput"
          />
        </Form>
      );
    }

    return (
      <div>
        <div className="step-txt">
          Step2. 회원가입 링크 전송 정보입력
          <span className="count">성공 {totalList - invalidLength}</span>
          <span className="count col-red">실패 {invalidLength}</span>
        </div>

        <div className="list-scroll">{txtArea}</div>

        {btnArea}

        <RefreshModal modalFn={modalFn} />
      </div>
    );
  }
}

StaffListAdd = connect(
  (state) => ({
    checkStaff: state.company.check
  }),
  (dispatch) => ({})
)(StaffListAdd);

export default StaffListAdd;
